import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { waitFor } from 'lp-hoc'
import { selectors as globalSelectors } from 'artist-portal-reducer'
import * as Types from 'types'
import { LoadingSpinner, Card, RenderedHtml } from 'components'
import { ProfileCompletionCard, Stats } from '../components'
import { useCommunity, useCommunityText } from 'utils'

const propTypes = {
  artist: Types.artist.isRequired,
}

function Dashboard({ artist }) {
  const t = useCommunityText()
  const { teachingArtistProfileCompletionEnabled } = useCommunity()
  const dashboardText = t('artistPortal.dashboard.welcomeMessage')

  return (
    <div>
      {dashboardText && (
        <Card>
          <div className="rendered-html">
            <RenderedHtml addAttrs={['target']}>{dashboardText}</RenderedHtml>
          </div>
        </Card>
      )}
      {teachingArtistProfileCompletionEnabled && (
        <ProfileCompletionCard artist={artist} />
      )}
      <Stats artist={artist} />
    </div>
  )
}

Dashboard.propTypes = propTypes

function mapStateToProps(state) {
  return {
    artist: globalSelectors.artist(state),
  }
}

export default compose(
  connect(mapStateToProps),
  waitFor('artist', LoadingSpinner)
)(Dashboard)
